import * as Icons from 'lucide-react'

const DynamicIcon = ({ name, size = 16, className = '' }) => {
  const Icon = Icons[name]
  if (!Icon) return <Icons.Package size={size} className={className} />
  return <Icon size={size} className={className} />
}

export default DynamicIcon